//设计资源展示
import { Card, Image, Flex } from 'antd';
import { useEffect, useState } from 'react'
import { Link } from "react-router-dom";

import '../DesignResDisplay/index.scss'
import { getDesignResListAPI } from '@/apis/design';
import { SERVER_CONF } from '@/config/server'
const BASE_SERVER_URL_LOCAL = SERVER_CONF.BASE_URL

const ShowDesignRes = () => {
    const [designResList, setDesignResList] = useState([])

    useEffect(() => {
        async function getDesignResList() {
            try {
                const res = await getDesignResListAPI()
                setDesignResList(res.data)
            } catch (error) {
                console.error("Error fetching design resources:", error);
            }
        }
        getDesignResList()
    }, [])

    return (
        <Flex>
            {designResList.map((designRes, index) => (
                <Card
                    title={designRes.projectName}
                    key={index}
                    hoverable
                    cover={<Image className='card-img' src={BASE_SERVER_URL_LOCAL + designRes.photo} alt='' />}
                    className='card'
                    style={{
                        width: 300,
                    }}
                    extra={
                        <Link to={`/DesignResDetail?id=${designRes.id}`}>
                            More
                        </Link>
                    }
                >
                </Card>
            ))}
        </Flex>
    )
}

export default ShowDesignRes